// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, multiline-comment-style, default-case, babel/camelcase */
import BookingPendingRefund from "@kiwicom/frontend-app/scripts/containers/mutable/BookingPendingRefund"
import type Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import { PASSENGER_CATEGORIES } from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import Flight from "@kiwicom/frontend-common/records/Flight"
import type Journey from "@kiwicom/frontend-common/records/Journey"
import PendingRequest from "@kiwicom/frontend-common/records/PendingRequest"
import {
  bookingDataSelector,
  bookingStateSelector,
} from "@kiwicom/frontend-common/services/booking/booking"

import getTranslateSelector from "@kiwicom/frontend-common/services/intl/translateSelector"
import { BAGS_TYPES } from "@kiwicom/frontend-common/types/bags"
import type { OrderedMap, OrderedSet } from "immutable"
import { List } from "immutable"
// @ts-expect-error: Flow to TS migration.
import _ from "lodash"

// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"
import type Moment from "moment"
import moment from "moment"
import * as R from "ramda"
import { createSelector, OutputSelector } from "reselect"
import { PassengerId } from "@kiwicom/frontend-common/types/primitiveTypes"
import { GUARANTEE_CASES } from "@kiwicom/frontend-common/components/Itinerary/ItineraryGuarantee"
import { GuaranteeCase } from "@kiwicom/frontend-common/components/Itinerary/ItineraryGuarantee"
import type AdditionalService from "@kiwicom/frontend-common/records/AdditionalService"
import { ReservationsDetails } from "@kiwicom/frontend-common/components/Itinerary/SegmentPNR/types"

import { Baggage } from "../../../../../common/types/baggageTypes"
import { SERVICES, SERVICES_STATUSES } from "../../../../../consts/additionalServices"
import { ACTIONS } from "../../../../../consts/booking"
import { MMB_SOURCE } from "../../../../../consts/common"
import { RefundMethods } from "../../../../../records/bookingInput"
import { FARE_TYPE_REFUND_DEADLINE_HOURS } from "./fareType/services/consts"
import { GUARANTEE_BANNER } from "./mapper/services/mapperGuarantee"
import { REFUND_OFFER_TYPE, RefundOffer, RefundOffers } from "./refundConsts"
import { DisplayStatus } from "../../../../../types/primitiveTypes"

// NOTE all these will be renamed after merge of ScheduleChanges

/** gets flights history */
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flightsHistorySelector: OutputSelector<any, undefined, List<Journey>> = createSelector(
  bookingDataSelector,
  // @ts-expect-error: Flow to TS migration.
  (booking) => booking.flightsHistory,
)

/** gets passengers */
export const bookingPassengersSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Passenger[],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (res: any) => Passenger[]
> = fp.compose(fp.get("passengers"), bookingDataSelector)

/** gets passenger ids */
// @ts-expect-error: Flow to TS migration.
export const passengerIdsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  PassengerId[]
> = createSelector(bookingPassengersSelector, (passengers) =>
  passengers.map((passenger) => passenger.id),
)

/** gets passenger by the ID from the booking's passengers */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const currentBookingSpecificPassengerSelector = (state: any, pid: number): Passenger =>
  // @ts-expect-error: Flow to TS migration.
  _.find(bookingPassengersSelector(state), (pax) => pax.id === pid)

/** gets available refund methods for whole booking ( not pending refunds ) */
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const refundMethodsSelector: OutputSelector<any, undefined, RefundMethods> = createSelector(
  bookingDataSelector,
  // @ts-expect-error: Flow to TS migration.
  (data) => data.refundMethods,
)

/** gets pending refund */
export const pendingRefundSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  BookingPendingRefund | null | undefined,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (res: any) => BookingPendingRefund | null | undefined
> = createSelector(bookingDataSelector, (data) => data.pendingRefund)

/** gets passthrough booking */
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isPassthroughBookingSelector: OutputSelector<any, undefined, boolean> = createSelector(
  bookingDataSelector,
  // @ts-expect-error: Flow to TS migration.
  (data) => data.isPassthroughBooking,
)

/** gets pending requests */
export const pendingRequestsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  // @ts-expect-error: Flow to TS migration.
  OrderedMap<PendingRequest>
  // @ts-expect-error: Flow to TS migration.
> = createSelector(bookingDataSelector, (data) => data.pendingRequests)

/**
 * gets pending additional services from booking
 * TODO: type AdditionalService
 */
// @ts-expect-error: Flow to TS migration.
export const bookingAdditionalServicesSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  // @ts-expect-error: Flow to TS migration.
  OrderedSet<AdditionalService>
  // @ts-expect-error: Flow to TS migration.
> = createSelector(bookingDataSelector, (data) => data.additionalServices)

/** get the journey */
// @ts-expect-error: Flow to TS migration.
export const currentBookingJourneySelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  Journey
> = createSelector(
  [bookingDataSelector],
  // @ts-expect-error: Flow to TS migration.
  (booking) => booking.journey,
)

/** get the journey with hidden flights included */
// @ts-expect-error: Flow to TS migration.
export const currentBookingJourneyWithHiddenSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Journey
> = createSelector(
  [bookingDataSelector],
  // @ts-expect-error: Flow to TS migration.
  (booking) => booking.journeyWithHidden,
)

/** get current guarantee case */
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const guaranteeCaseSelector: OutputSelector<any, any, GuaranteeCase> = createSelector(
  [bookingDataSelector],
  ({ guarantee: { guaranteeBanner } }) => {
    switch (guaranteeBanner) {
      case GUARANTEE_BANNER.PAID_META_PARTNER_VI:
        return GUARANTEE_CASES.META_PARTNER_PAID
      case GUARANTEE_BANNER.NOT_PAID_META_PARTNER_VI:
        return GUARANTEE_CASES.META_PARTNER_NOT_PAID
      case GUARANTEE_BANNER.PAID_VI:
      case GUARANTEE_BANNER.PAID_NON_VI:
        return GUARANTEE_CASES.PAID
      case GUARANTEE_BANNER.NOT_PAID_VI:
      case GUARANTEE_BANNER.NOT_PAID_NON_VI:
        return GUARANTEE_CASES.NOT_PAID
      case GUARANTEE_BANNER.LEGACY:
        return GUARANTEE_CASES.LEGACY
      case GUARANTEE_BANNER.HIDDEN:
      default:
        return GUARANTEE_CASES.HIDDEN
    }
  },
)

/** get the flights ids from the journey (currently includes ground transport) */
// @ts-expect-error: Flow to TS migration.
export const bookingFlightIdsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  List<string>
  // @ts-expect-error: Flow to TS migration.
> = createSelector(currentBookingJourneySelector, (journey) => journey.getFlightsIds())

// @ts-expect-error: Flow to TS migration.
export const currentBookingFlightsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  List<Flight>,
  (res: Journey) => List<Flight>
  // @ts-expect-error: Flow to TS migration.
> = createSelector(currentBookingJourneySelector, (journey) => journey.getFlights())

/** returns first flight in the journey (currently includes ground transport) */
// @ts-expect-error: Flow to TS migration.
export const currentBookingFirstFlightSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  Flight
  // @ts-expect-error: Flow to TS migration.
> = createSelector(currentBookingJourneySelector, (journey) => journey.getFlights().first())

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translateSelector: any = (state) => getTranslateSelector(state)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const successMessageSelector: any = createSelector(
  [bookingStateSelector, translateSelector],
  (state, translate) => {
    if (state.success) {
      switch (state.success.action) {
        case ACTIONS.CANCEL_BOOKING:
          // @ts-expect-error: Flow to TS migration.
          return translate("account.booking_cancel_success")
        case ACTIONS.REQUEST_FAST_REFUND:
          // @ts-expect-error: Flow to TS migration.
          return [translate("account.booking_fast_refund_success")].join(" ")
      }
    }
    return null
  },
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingChangesSelector: any = createSelector(
  bookingDataSelector,
  // @ts-expect-error: Flow to TS migration.
  (booking) => booking.bookingChanges,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldShowBookingRequestsSelector: OutputSelector<any, any, boolean> = createSelector(
  bookingChangesSelector,
  // @ts-expect-error: Flow to TS migration.
  (bookingChanges) => bookingChanges.length > 0,
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasStrollerToRecheckSelector: any = createSelector(bookingDataSelector, (booking) => {
  return (
    // @ts-expect-error: Flow to TS migration.
    booking.infantsConditions.trolley &&
    // @ts-expect-error: Flow to TS migration.
    booking.passengers.filter((p) => p.category === PASSENGER_CATEGORIES.infant).length > 0
  )
})

const getHoldBagsCount = (bags: Baggage[]): number =>
  // @ts-expect-error: Flow to TS migration.
  R.compose(
    R.length,
    // @ts-expect-error: Flow to TS migration.
    R.filter((bag) => bag.bag.category === BAGS_TYPES.HOLD_BAG),
    R.ifElse(R.isEmpty, R.always([]), R.head),
    R.values,
    // @ts-expect-error: Flow to TS migration.
    R.groupBy((bag) => bag.flightId),
  )(bags)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasBaggageOrServicesSelector: any = createSelector(bookingDataSelector, (booking) => {
  // @ts-expect-error: Flow to TS migration.
  const hasHoldBags = getHoldBagsCount(booking.baggages) > 0
  const hasAdditionalEquipment =
    // @ts-expect-error: Flow to TS migration.
    booking.additionalServices.filter(
      // @ts-expect-error: Flow to TS migration.
      (service) =>
        (service.category === SERVICES.PETS ||
          service.category === SERVICES.SPORTS_EQUIPMENT ||
          service.category === SERVICES.MUSICAL_EQUIPMENT) &&
        service.status === SERVICES_STATUSES.CONFIRMED,
    ).size > 0

  return hasHoldBags || hasAdditionalEquipment
})

// NOTE: only for Baggage modal for informing in advance regarding recheck (when customer doesn't have any chb yet)
// @ts-expect-error: Flow to TS migration.
export const showBaggageRecheckNoteBeforeOrderSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  boolean
> = createSelector(
  [currentBookingJourneySelector],
  (journey) =>
    // @ts-expect-error: Flow to TS migration.
    journey.hasBagsRecheck() &&
    // @ts-expect-error: Flow to TS migration.
    journey
      .getStops()
      // show if at least one flight->flight stop with required recheck baggage in journey
      // @ts-expect-error: Flow to TS migration.
      .some((stop) => stop.get("isLayoverBetweenFlights") && stop.get("bagsRecheckRequired")),
)

// for Baggage recheck note in Baggage card when customer has already checked baggage added
// @ts-expect-error: Flow to TS migration.
export const showBaggageRecheckNoteSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  boolean
> = createSelector(
  [hasBaggageOrServicesSelector, showBaggageRecheckNoteBeforeOrderSelector],
  (hasBaggage, showNoteBeforeOrder) => hasBaggage && showNoteBeforeOrder,
)

// @ts-expect-error: Flow to TS migration.
export const showStrollerRecheckNoteSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  boolean
> = createSelector(
  [hasStrollerToRecheckSelector, showBaggageRecheckNoteBeforeOrderSelector],
  (hasStroller, showNoteBeforeOrder) => hasStroller && showNoteBeforeOrder,
)

// returns boolean
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBeforeFareTypeRefundDeadlineSelector: any = createSelector(
  [currentBookingJourneySelector],
  (journey) => {
    // @ts-expect-error: Flow to TS migration.
    const firstFlightDepartureTime = journey.trips
      .first()
      .parts.first()
      .departure.getIn(["when", "utc"])
    return (
      moment.duration(firstFlightDepartureTime.diff()).asHours() > FARE_TYPE_REFUND_DEADLINE_HOURS
    )
  },
)

// returns hours moment as a deadline
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fareTypeRefundDeadlineDateSelector: OutputSelector<any, any, Moment> = createSelector(
  [currentBookingJourneySelector],
  (journey) => {
    // @ts-expect-error: Flow to TS migration.
    const firstFlightDepartureTime = journey.trips
      .first()
      .parts.first()
      .departure.getIn(["when", "utc"])
    return moment(firstFlightDepartureTime).subtract(FARE_TYPE_REFUND_DEADLINE_HOURS, "hours")
  },
)

export const checkInSelector = R.compose(R.prop("checkIn"), bookingDataSelector)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const bookingStatusSelector: any = createSelector([bookingDataSelector], (booking) => {
  // @ts-expect-error: Flow to TS migration.
  return booking.status
})

// @ts-expect-error: Flow to TS migration.
export const allowedToChangePassengersSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  number
  // @ts-expect-error: Flow to TS migration.
> = createSelector([bookingDataSelector], (booking) => booking.config.allowedToChange.passengers)

/**
 * source param used in MMB to track where the user came from
 * - returns value from URL source param
 * - returns tram: when deeplink and utm_medium=tram in the URL query
 * - returns mmb: all other cases
 * @returns {string}
 * */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sourceParamSelector = (state: any): string => {
  const { source, utm_medium } = state.query

  if (source) {
    return source
  }

  if (utm_medium === "tram") {
    return utm_medium
  }

  return MMB_SOURCE
}

export const refundOffersSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  RefundOffers,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (res: any) => RefundOffers
> = createSelector([bookingDataSelector], (booking) => booking.refundOffers)

// only 1 non-processed booking refund offer can be displayed at time (same as pending refund)
export const nonProcessedBookingRefundOfferSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  RefundOffer | null,
  (res: RefundOffers) => RefundOffer | null
> = createSelector(
  [refundOffersSelector],
  (refundOffers) =>
    refundOffers.find((offer: RefundOffer) => offer.type === REFUND_OFFER_TYPE.TECHNICAL_ISSUE) ??
    null,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayStatusSelector: OutputSelector<any, any, DisplayStatus> = createSelector(
  [bookingDataSelector],
  // @ts-expect-error: Flow to TS migration.
  (booking) => booking.displayStatus,
)

// @ts-expect-error: Flow to TS migration.
export const reservationsDetailsSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ReservationsDetails
  // @ts-expect-error: Flow to TS migration.
> = createSelector([bookingDataSelector], (booking) => booking.reservationsDetails)
